export { default as TableWidget } from "./table_widget_container";
import * as TableWidgetFactory from "./table_widget_factory";
export { default as WidgetEditTable } from "./table_widget_form";
export { TableWidgetFactory };
